'use client';

import Script from 'next/script';

const Rb2bScript = () => (
	<Script
		id="rb2b-script"
		strategy="lazyOnload"
		dangerouslySetInnerHTML={{
			__html: `
					!function(key) {if (window.reb2b) return;window.reb2b = {loaded: true};var s = document.createElement("script");s.async = true;s.src = "https://ddwl4m2hdecbv.cloudfront.net/b/" + key + "/" + key + ".js.gz";document.getElementsByTagName("script")[0].parentNode.insertBefore(s, document.getElementsByTagName("script")[0]);}("Z6PVLHP4Q06R");
				`
		}}
	/>
);

export default Rb2bScript;
